module.exports = __webpack_public_path__ + "static/share-82e79afd4688cfcb93494219a69131fb.png";